// extracted by mini-css-extract-plugin
export var active = "_cw-2";
export var recordingDot = "_cw-1";
export var recordingIndicator = "_cw-0";